import { GET_CATEGORY } from "./category";
import { STORE_ITEM } from "./store";

const itemFactory = ({
  title,
  alias,
  basePrice,
  price,
  images,
  store,
  sizeAlias = 'mini',
  serviceTime,
  description,
  content,
  notice,
  times
} = {}) => {
  return {
    "title": title ?? "A. 小美容",
    "alias": alias ?? "store-small-dog-a",
    "basePrice": basePrice ?? 1000,
    "price": price ?? 700,
    "images": images ?? [
      {
        "path": "https://assets.codepen.io/1759070/service-1%402x.png",
        "default": 1
      },
      {
        "path": "https://assets.codepen.io/1759070/service-2%402x.png",
        "default": 0
      },
      {
        "path": "https://assets.codepen.io/1759070/service-3%402x.png",
        "default": 0
      }
    ],
    "store": store ?? STORE_ITEM,
    "categoryAlias": GET_CATEGORY(sizeAlias).categoryAlias,
    "categoryTitle": GET_CATEGORY(sizeAlias).categoryTitle,
    "sizeAlias": GET_CATEGORY(sizeAlias).sizeAlias,
    "sizeTitle": GET_CATEGORY(sizeAlias).sizeTitle,
    "serviceTime": serviceTime ?? 120,
    "description": description ?? "迷你犬基礎洗護（含：剪指甲、清耳朵、小修臉部雜毛、小修足緣、剃腳底毛、剃肚子毛、剃肛門毛擠肛門腺+牛奶SPA浴程）",
    "content": content ?? "本店使用法國進口armin寵物狗專用沐浴乳，溫和清香不刺激，皮膚病與敏感肌膚狗狗皆可使用。\n本店洗澡全程溫控32度溫水清洗，讓狗狗有如做spa般享受整個洗澡過程。\n本店使用法國進口armin寵物狗專用沐浴乳，溫和清香不刺激，皮膚病與敏感肌膚狗狗皆可使用。",
    "notice": notice ?? "※ 目前暫無提供具攻擊性犬隻美容服務\n※ 全身打結不剃毛恕無法提供服務，拆結過程易導致皮膚發炎\n※ 全身嚴重跳蚤壁蝨／嚴重皮膚病恕無法提供服務，請先尋求獸醫治療",
    "times": times ?? [
      "10:00",
      "10:30",
      "11:00",
      "11:30",
      "12:00",
      "12:30",
      "13:00",
      "14:00",
      "14:30",
      "15:00",
      "15:30",
      "16:00",
      "16:30",
      "17:00",
      "17:30",
      "18:00",
      "18:30"
    ],
  }
};

export const RESERVATION_LIST = [
  itemFactory({
    "title": "A. 小美容",
    "alias": "store-small-dog-a",
    "basePrice": 1000,
    "price": 700,
    "images": [
      {
        "path": "https://assets.codepen.io/1759070/service-1%402x.png",
        "default": 1
      },
      {
        "path": "https://assets.codepen.io/1759070/service-2%402x.png",
        "default": 0
      },
      {
        "path": "https://assets.codepen.io/1759070/service-3%402x.png",
        "default": 0
      }
    ],
    "serviceTime": 120,
    "times": [
      "10:00",
      "10:30",
      "11:00",
      "11:30",
      "12:00",
      "12:30",
      "13:00",
      "14:00",
      "14:30",
      "15:00",
      "15:30",
      "16:00",
      "16:30",
      "17:00",
      "17:30",
      "18:00",
      "18:30"
    ],
  }),
  itemFactory({
    "title": "B. 小美容牛奶SPA",
    "alias": "store-small-dog-b",
    "basePrice": 700,
    "price": 700,
    "images": [
      {
        "path": "https://assets.codepen.io/1759070/service-1%402x.png",
        "default": 0
      },
      {
        "path": "https://assets.codepen.io/1759070/service-2%402x.png",
        "default": 1
      },
      {
        "path": "https://assets.codepen.io/1759070/service-3%402x.png",
        "default": 0
      }
    ],
    "serviceTime": 60,
    "times": []
  }),
  itemFactory({
    "title": "C. 大美容",
    "alias": "store-small-dog-c",
    "basePrice": 700,
    "price": 700,
    "images": [],
    "serviceTime": 300,
    "times": []
  })
];

export const RESERVATION_ITEM = itemFactory();
